import { DashboardRouter } from "../dashboard.router";

export class CreateHospitalCenterRouter {
    
    static getRoute(): string {
        return `${DashboardRouter.getRoute()}/create-hospital-center`
    }

}